import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { CandidatoService } from '../../candidato/candidato.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import { CursoEspecializadoService } from '../../../services/curso-especializado.service';
import { SigopServiceService } from '../../../services/sigop-service.service';
import { CandidatoCursoEspecializadoService } from '../../../services/candidato-curso-especializado.service';
import { CandidatoCursoEspecializado } from '../../../models/candidatoCursoEspecializado';

@Component({
  selector: 'sispac-cadastar-curso-pratico',
  templateUrl: './cadastar-curso-pratico.component.html',
  styleUrls: ['./cadastar-curso-pratico.component.css']
})
export class CadastarCursoPraticoComponent extends WebPage implements OnInit {
  idCandidato;
  candidato;
  listaCursosPraticos;
  cursoSigop;
  form: FormGroup;
  candidatoCurso = new CandidatoCursoEspecializado();
  msgTurmaNaoConcluida = 'Turma ainda não concluída. Não é possível alterar o status do aluno';

  constructor(
    messageService: MessageService,
    private candidatoService: CandidatoService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private cursoEspecializadoService: CursoEspecializadoService,
    private candidatoCursoEspecializadoService: CandidatoCursoEspecializadoService,
    private sigopServiceService: SigopServiceService
  ) {
    super(messageService);
    this.route.paramMap.subscribe(
      params => (this.idCandidato = params.get('idCandidato'))
    );

    this.form = fb.group({
      curso: [null, Validators.required],
      turma: [null, [Validators.required, Validators.pattern('^[0-9]*$')]]
    });
  }

  ngOnInit() {
    this.carregarCandidato();
    this.carregarCursos();
  }

  carregarCursos() {
    this.cursoEspecializadoService
      .getNotInCandidato(this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        listaCursosPraticos => {
          this.listaCursosPraticos = listaCursosPraticos;
        },
        error => this.gerenciaErro(error)
      );
  }

  pesquisarCurso() {
    if (this.form.value.curso === null || this.form.value.curso === '') {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro!',
        detail: 'Informe um Curso'
      });
      return;
    }

    if (this.form.value.turma !== '' && this.form.value.turma != null) {
      this.sigopServiceService
        .getByCpfAndTurma(this.candidato.cpf, this.form.value.turma)
        .finally(() => (this.isLoading = false))
        .subscribe(
          cursoSigop => {
            // this.cursoSigop = cursoSigop;
            // console.log(cursoSigop);
            // if (this.cursoSigop === null) {
            //   this.messageService.add({ severity: 'error', summary: 'Erro!', detail: 'Código da turma informada não existe no SIGOP' });
            // }

            if (cursoSigop === 'ALUNO_NAO_MATRICULADO') {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Este aluno não está matriculado na turma informada'
              });
            } else if (cursoSigop === 'TURMA_NAO_EXISTE') {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Código da turma informada não existe no SIGOP'
              });
            } else {
              this.cursoSigop = cursoSigop;
            }
          },
          error => this.gerenciaErro(error)
        );
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro!',
        detail: 'Informe o número de turma!'
      });
    }
  }

  carregarCandidato() {
    this.isLoading = true;
    this.candidatoService
      .getFull(this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        candidato => {
          this.candidato = candidato;
          // console.log(this.candidato);
        },
        error => this.gerenciaErro(error)
      );
  }

  salvarCurso() {
    if (this.form.value.curso === null || this.form.value.curso === '') {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro!',
        detail: 'Informe um Curso'
      });
      return;
    }
    // console.log(this.cursoSigop.idStatusTurma);
    if (this.cursoSigop.idStatusTurma !== 656) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro!',
        detail: this.msgTurmaNaoConcluida
      });
      return;
    }

    this.confirmationService.confirm({
      message:
        '<h3><font color="red">Tem certeza que o curso e a turma selecionados são concordantes?</font></h3>',
      header: 'Confirmação',
      // icon: 'fa fa-question-circle',
      accept: () => {
        if (this.cursoSigop != null) {
          this.candidatoCurso.idCandidato = this.candidato.idCandidato;
          this.candidatoCurso.idCursoEspecializado = this.form.value.curso;
          this.candidatoCurso.codigoTurmaSigop = this.form.value.turma;
          this.candidatoCurso.statusAluno = this.cursoSigop.resultado;
          this.candidatoCurso.statusTurma = this.cursoSigop.statusTurma;
          this.candidatoCurso.idStatusTurma = this.cursoSigop.idStatusTurma;

          this.candidatoCursoEspecializadoService
            .cadastrar(this.candidatoCurso)
            .finally(() => (this.isLoading = false))
            .subscribe(
              resultado => {

                console.log(resultado);
                this.form.reset();
                this.carregarCursos();
                this.cursoSigop = {} as any;

                if (resultado === 'TURMA_AINDA_NAO_CONCLUIDA') {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: this.msgTurmaNaoConcluida
                  });
                } else {
                  this.router.navigate([
                    '/curso-pratico/gerenciar-cadastrar',
                    this.idCandidato
                  ]);
                }
              },
              error => this.gerenciaErro(error)
            );
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro!',
            detail: 'Código da turma informada não existe no SIGOP'
          });
        }
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate([
          '/curso-pratico/gerenciar-cadastrar',
          this.idCandidato
        ]);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cursoPratico/cadastar-curso-pratico/cadastar-curso-pratico.component.ts